// extracted by mini-css-extract-plugin
export default {"AddonAcceptPage":"_6BRUDVGTLvK75H6VAX4WYA==","AddonAcceptContent":"VdN-VwsygEuv4Iiyd5OX2g=="};